//退款管理
export default {
	//基础配置-登记权限-新增-编辑
	registerSaveOrUpdate: {
		url: '/ec-pc-api/refund/manage/storeUser/register/saveOrUpdate',
		type: 'post'
	},
	//基础配置-登记权限-删除
	registerDel: {
		url: '/ec-pc-api/refund/manage/register/del',
		type: 'get'
	},
	//基础配置-审核权限-编辑
	auditSaveOrUpdate: {
		url: '/ec-pc-api/refund/manage/storeUser/audit/saveOrUpdate',
		type: 'post'
	},
	//基础配置-审核权限-删除
	reportStatusList: {
		url: '/ec-pc-api/refund/manage/auditUser/del',
		type: 'get'
	},
	//用户店铺权限下拉列表(1登记权限 2审核权限)
	userStoreList: {
		url: '/ec-pc-api/refund/manage/userStoreList',
		type: 'get'
	},
	//退款登记-根据平台单号查询订单信息
	registerInfoOrderInfo: {
		url: '/ec-pc-api/refund/manage/registerInfo/orderInfo',
		type: 'get'
	},
	//退款登记-ECO-新增-编辑
	ecoSaveOrUpdate: {
		url: '/ec-pc-api/refund/manage/registerInfo/eco/saveOrUpdate',
		type: 'post'
	},
	//退款登记-删除
	registerInfoDel: {
		url: '/ec-pc-api/refund/manage/registerInfo/del',
		type: 'get'
	},
	//退款登记-B2C-新增-编辑
	b2cSaveOrUpdate: {
		url: '/ec-pc-api/refund/manage/registerInfo/b2c/saveOrUpdate',
		type: 'post'
	},
	//线下审核-ECO-操作(驳回-通过-上传附件-删除附件)
	ecoOperation: {
		url: '/ec-pc-api/refund/manage/auditInfo/eco/operation',
		type: 'post'
	},
	//线下审核-ECO-编辑
	ecoAuditInfoUpdate: {
		url: '/ec-pc-api/refund/manage/auditInfo/eco/update',
		type: 'post'
	},
	//线下审核-ECO-审核
	ecoAuditInfoAduit: {
		url: '/ec-pc-api/refund/manage/auditInfo/eco/aduit',
		type: 'post'
	},
	//线下审核-ECO-删除
	auditInfoDel: {
		url: '/ec-pc-api/refund/manage/auditInfo/del',
		type: 'get'
	},
	//线下审核-ECO-导出
	exportEcoAuditInfo: {
		url: '/ec-pc-api/refund/manage/export/eco/auditInfo',
		type: 'post'
	},
	//线下审核-B2C-编辑
	b2cAuditInfoUpdate: {
		url: '/ec-pc-api/refund/manage/auditInfo/b2c/update',
		type: 'post'
	},
	//线下审核-B2C-审核
	b2cAuditInfoAduit: {
		url: '/ec-pc-api/refund/manage/auditInfo/b2c/aduit',
		type: 'post'
	},
	//导出B2C-退款登记信息
	b2cRegisterInfoExport: {
		url: '/ec-pc-api/refund/manage/export/b2c/registerInfo',
		type: 'post'
	},
	//导出B2C-线下审核信息
	b2cAuditInfoExport: {
		url: '/ec-pc-api/refund/manage/export/b2c/auditInfo',
		type: 'post'
	},
	//线下审核-未审核数量统计
	auditInfoUnAuditSummary: {
		url: '/ec-pc-api/refund/manage/auditInfo/unAudit/summary',
		type: 'get'
	},
	//退款汇总-导出
	summaryInfoExport: {
		url: '/ec-pc-api/refund/manage/export/summaryInfo',
		type: 'post'
	},
	//用户平台权限下拉列表(1登记权限 2审核权限)
	userPlatList: {
		url: '/ec-pc-api/refund/manage/userPlatList',
		type: 'get'
	},
	//退款登记-查询存在记录数
	registerInfoExist: {
		url: '/ec-pc-api/refund/manage/registerInfo/exist',
		type: 'get'
	},
	//下拉条件集合
	queryCriteriaList: {
		url: '/ec-pc-api/refund/manage/queryCriteriaList',
		type: 'get'
	},
	//导入文件记录查询
	fileListPage: {
		url: '/ec-pc-api/file/listPage',
		type: 'post'
	},
	//文件上传
	fileUpload: {
		url: '/ec-file-api/file/upload',
		type: 'post'
	},
	//附件预览
	appendixPreview: {
		url: '/ec-pc-api/refund/manage/appendix/preview',
		type: 'post'
	},
	//线下审核-更新打款结果
	paymentResultsEdit: {
		url: '/ec-pc-api/refund/manage/auditInfo/paymentResults/edit',
		type: 'post'
	},
	//终止
	termination: {
		url: '/ec-pc-api/refund/manage/termination',
		type: 'get'
	},
	//锁定审核数据(更新为审核中)
	manageLock: {
		url: '/ec-pc-api/refund/manage/lock',
		type: 'post'
	},
	//解锁审核数据(更新为未审核)
	manageUnLock: {
		url: '/ec-pc-api/refund/manage/unLock',
		type: 'post'
	},
	//导出前锁定审核数据(更新为审核中)
	manageUnLockBeforeImport: {
		url: '/ec-pc-api/refund/manage/lock/beforeImport',
		type: 'post'
	},
	//媒体文件上传
	uploadMedia: {
		url: '/ec-file-api/file/upload/media',
		type: 'post'
	},
}